import type { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const styles = {
  tableContainer: (theme: Theme) => ({
    width: '100%',
    maxHeight: '100%',
    borderRadius: '0.5rem',
    boxShadow: `0px 4px 23px 0px ${alpha(theme.colors.black, 0.2)}`,
  }),

  footer: {
    p: 0,
    borderBottom: 'none',
  },
};
